import axios from "axios";

function verifyFACode(obj) {
  return new Promise((resolve, reject) => {
    const url = `${process.env.REACT_APP_API}/api/user/verifyCode`;

    axios
      .post(url, obj)
      .then(async (response) => {
        resolve(true);
      })
      .catch((error) => {
        reject(false);
      });
  });
}
export default verifyFACode;
